export default __webpack_public_path__ + "static/media/english_lang.0549c772.png";